import {useStylesECDS} from '../ecdsStyle';
import {useTranslation} from 'react-i18next';
import {TableCell, TableHead, TableRow} from '@mui/material';
import clsx from 'clsx';

const EcdsTableHeader = () => {
    const {t} = useTranslation();
    const classes = useStylesECDS();

    return (
        <TableHead>
            <TableRow>
                <TableCell className={clsx(classes.headCell, 'refresh')} size="small"/>

                <TableCell className={clsx(classes.headCell, 'refresh')} align="left" size="small">
                    {t('No')}
                </TableCell>

                <TableCell className={clsx(classes.headCell, 'refresh')} align="center"
                           size="small">
                    {t('Observation Completed')}
                </TableCell>

                <TableCell className={clsx(classes.headCell, 'refresh')} align="center"
                           size="small">
                    {t('By')}
                </TableCell>

                <TableCell className={clsx(classes.headCell, 'refresh')} align="center"
                           size="small">
                    {t('Status')}
                </TableCell>

                <TableCell className={clsx(classes.headCell, 'refresh')} align="center"
                           size="small">
                    {t('Amend Timestamp')}
                </TableCell>
            </TableRow>
        </TableHead>
    );
};

export default EcdsTableHeader;